import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_date_technical } from '../../functions/functions_formatting.js';
import { getToken } from '../../functions/app_functions.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js';


export default class TripDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collections_updated: [],
            rate_updated: null,
            updated: false,
            status: null
        };
        this.updateData = this.updateData.bind(this);
        this.setRating = this.setRating.bind(this);
    }


    componentDidMount() {
        this.setState({
            collections_updated: this.props.tripdata.collection,
            rate_updated: this.props.tripdata.rate
        });
    }


    toggleCollections(collection) {
        var data = this.state.collections_updated;
        if (data.includes(collection)) {
            data = data.filter(item => item !== collection);
        } else {
            data.push(collection);
        }
        this.setState({
            collections_updated: data,
            updated: true
        })
    }


    setRating(label, value) {
        this.setState({
            rate_updated: value,
            updated: true
        });
    }


    async updateData() {
        try {
            var data = {
                collection: this.state.collections_updated,
                rate: this.state.rate_updated
            };
            var trip_id = this.props.tripdata.trip_id;
            // Send request
            var response = await fetch(this.props.baseUrl + "/adminupdatetripdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    trip_id: trip_id,
                    data: data
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                // Set success message
                this.setState({
                    status: "Updated",
                    updated: false
                });
                this.props.loadTripData();
            } else {
                // Track error
                var name = "";
                var message = "Could not update data. Please check the URL and try again.";
                this.props.setError(name, message);
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not update data. Please check the URL and try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "UserDetails_updateData");
        }
    }


    render() {
        return (
            <>
                <div className="admindashboard__section">
                    <div className="admindashboard__section__title text-title">
                        Trip
                    </div>
                    <div className="admindashboard__section__content">

                        {this.props.tripdata &&
                            <>
                                <div className="admindashboard__section__content__table admindashboard__section__content__table--userdetails">

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Trip ID
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.props.tripdata.trip_id}
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Title
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.props.tripdata.title}
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Collections
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--flex">
                                        {this.props.collections && this.props.collections.length >= 1 && this.props.collections.map((el, i) =>
                                            <div key={i} onClick={() => this.toggleCollections(el)} className={"label" + (this.state.collections_updated.includes(el) ? "" : " label--unselected")}>
                                                {el}
                                            </div>
                                        )}
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Guidr rating
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.state.rate_updated &&
                                            <ForminputDropdown
                                                name={"rating"}
                                                label={""}
                                                list={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                                                default_value={this.state.rate_updated}
                                                setFormValue={this.setRating.bind(this)}
                                                required={false}
                                            />
                                        }
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Cities
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.props.tripdata.cities.join(", ")}
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Countries
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.props.tripdata.countries.join(", ")}
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Activities
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.props.tripdata.activities_count}
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Trip views
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.props.tripdata.trip_views + " (" + this.props.tripdata.trip_views_last_30_days + " in last 30 days)"}
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Trip unlocks
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.props.tripdata.unlocks + " (" + this.props.tripdata.unlocks_last_30_days + " in last 30 days)"}
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Username
                                    </div>
                                    <Link to={"/u/" + this.props.tripdata.owner.username} className="admindashboard__section__content__table__element">
                                        {this.props.tripdata.owner.username}
                                    </Link>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        User ID
                                    </div>
                                    <div onClick={() => this.props.setUser(this.props.tripdata.owner_id)} className="admindashboard__section__content__table__element text-link">
                                        {this.props.tripdata.owner_id}
                                    </div>

                                </div>

                                {(this.state.updated) &&
                                    <div onClick={this.updateData} className="button button-primary">
                                        Update data
                                    </div>
                                }
                                {this.state.status &&
                                    <div className="text-color-primary">
                                        {this.state.status}
                                    </div>
                                }
                            </>
                        }

                    </div>
                </div>

            </>
        )
    }
}